export class ConnectSourceAccountRequest {
    'name';
    'sourceAccountAttributes';
    'isInternalAccount';
    'tags';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "sourceAccountAttributes",
            "baseName": "sourceAccountAttributes",
            "type": "SourceAccountAttributesInput",
            "format": ""
        },
        {
            "name": "isInternalAccount",
            "baseName": "isInternalAccount",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "tags",
            "baseName": "tags",
            "type": "{ [key: string]: string; }",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ConnectSourceAccountRequest.attributeTypeMap;
    }
    constructor() {
    }
}
